import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Automatyczne dodawanie tokenu do każdego zapytania w nagłówku Authorization
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sms_token") || localStorage.getItem("sms_p_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;
